import apiClient from "./apiClient";

export const api = {
    auth: {
        authTokens: (credentials) => apiClient.post('/authenticate',credentials),
        login: (credentials) => apiClient.post('/users/login', credentials),
        forgotPassword: (email) => apiClient.post('/forget_password',  email),
        changePassword: (data) => apiClient.post('/users/password', data),
    },
    users: {
        getAll: () => apiClient.get('/users'),
        addUser:(data) => apiClient.post('/users/add',data),
        deleteUser:(id)=>apiClient.post('/users/delete',id),
    },
    projects:{
        getAll: () =>apiClient.get('/projects'),
        updateStatus: (data) => apiClient.put('/projects/status', data),
        deleteProject: (id) => apiClient.post('/projects/delete',id),
        createProject: (formData) => apiClient.post('/extract',formData),
        downloadXml:(id) =>apiClient.post('/download/xml',id),
        downloadJson:(id) =>apiClient.post('/download/json',id),
        viewProjectpdf: (id) => apiClient.post('/view/file',id),
        getJsonContent: (id) => apiClient.post('/view/json',id),
        updateJsonContent:(data) => apiClient.post('/edit/json',data),
    },
    dashboard:{
        getDashboardSummary: () => apiClient.get('/dashboards')
    }

}